/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  UnbuttonTokenFactory,
  UnbuttonTokenFactoryInterface,
} from "../UnbuttonTokenFactory";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_template",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "instance",
        type: "address",
      },
    ],
    name: "InstanceAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "instance",
        type: "address",
      },
    ],
    name: "InstanceRemoved",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "args",
        type: "bytes",
      },
    ],
    name: "create",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "underlying",
        type: "address",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "initialRate",
        type: "uint256",
      },
    ],
    name: "create",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "instanceAt",
    outputs: [
      {
        internalType: "address",
        name: "instance",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "instanceCount",
    outputs: [
      {
        internalType: "uint256",
        name: "count",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "instance",
        type: "address",
      },
    ],
    name: "isInstance",
    outputs: [
      {
        internalType: "bool",
        name: "validity",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "template",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type UnbuttonTokenFactoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UnbuttonTokenFactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UnbuttonTokenFactory__factory extends ContractFactory {
  constructor(...args: UnbuttonTokenFactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _template: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<UnbuttonTokenFactory> {
    return super.deploy(
      _template,
      overrides || {}
    ) as Promise<UnbuttonTokenFactory>;
  }
  getDeployTransaction(
    _template: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_template, overrides || {});
  }
  attach(address: string): UnbuttonTokenFactory {
    return super.attach(address) as UnbuttonTokenFactory;
  }
  connect(signer: Signer): UnbuttonTokenFactory__factory {
    return super.connect(signer) as UnbuttonTokenFactory__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UnbuttonTokenFactoryInterface {
    return new utils.Interface(_abi) as UnbuttonTokenFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UnbuttonTokenFactory {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as UnbuttonTokenFactory;
  }
}
